/**
 * `useIsAdmin()` — true iff the principal carries the built-in workspace
 * admin token (`ws:admin` in `roles[]`). Custom roles are NOT admin here,
 * mirroring the retired server AdminRoleGuard's semantics; the server now
 * gates the Signing Keys surface on `signing-key:manage` (PermissionGuard).
 *
 * Per NFR-Design § 3. NFR-SEC-14 (defense-in-depth): hiding the Signing
 * Keys tab is UX polish; the server is the canonical security boundary.
 */

import { useCurrentPrincipal } from "./use-current-principal";

export function useIsAdmin(): boolean {
  const p = useCurrentPrincipal();
  return p.roles.includes("ws:admin");
}
